(() => {
  const scopeName = 'filter.p.product_type';
  const scopeValue = 'Steel Sign';
  const addField = (form, name, value) => {
    let field = form.querySelector(`input[name="${name}"]`);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  };

  // Retain customer keywords; filtering runs before native counts/pagination.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.origin);
    if (!action.pathname.endsWith('/search')) return;
    addField(form, 'type', 'product');
    addField(form, scopeName, scopeValue);
  }, true);

  // Use native navigation for search filter resets. This avoids stale mobile
  // drawer inputs being resubmitted while Dawn replaces facet markup.
  document.addEventListener('click', event => {
    if (!document.querySelector('[data-mn-sign-search]')) return;
    const link = event.target.closest('facet-remove a');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = new URL(link.href, window.location.origin);
    if (target.origin !== window.location.origin || !target.pathname.endsWith('/search')) return;
    target.searchParams.set('type', 'product');
    target.searchParams.set(scopeName, scopeValue);
    target.searchParams.delete('page');
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(target.href);
  }, true);

  // Normalize old/bookmarked search links only when Shopify exposes the filter.
  // Replacing this entry keeps Back to browsing from adding an extra history step.
  if (!document.querySelector('[data-mn-sign-search]')) return;
  const url = new URL(window.location.href);
  const scope = url.searchParams.getAll(scopeName);
  if (url.searchParams.get('type') === 'product' && scope.length && scope.every(value => value === scopeValue)) return;
  url.searchParams.set('type', 'product');
  url.searchParams.set(scopeName, scopeValue);
  url.searchParams.delete('page');
  window.location.replace(url.href);
})();
